import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import toastWrapper from '../../hoc/toastWrapper';
import { withShoppingBagRevampUX } from '../MemberCreditsCartToggle/WithShoppingBagRevampUX';

const ContainerStyled = styled.div`
  ${({ isShoppingBagRevampUX }) =>
    !isShoppingBagRevampUX &&
    `font-size: 12px;
    font-weight: 375;
    padding: ${props => props.theme.spacing.small}px;
    border-top: 1px solid
      ${props =>
        props.isMemberCreditApplied
          ? props.theme.colors.gray300
          : props.theme.colors.lavender150};
    background: ${props =>
      props.isMemberCreditApplied ? props.theme.colors.lavender250 : '#FAFAFD'};
    padding: 12px;
    margin: 0 ${props => props.theme.spacing.tiny}px 0;
    border-radius: 0 0 4px 4px;
  `};
  ${({ isShoppingBagRevampUX }) =>
    isShoppingBagRevampUX &&
    `
    border: none;
    padding: 12px 0;
  `}
`;

const Container = withShoppingBagRevampUX(ContainerStyled);

class PromoConflict extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isMemberCreditApplied: PropTypes.bool,
  };

  render() {
    const { className, isMemberCreditApplied } = this.props;

    return (
      <Container
        isMemberCreditApplied={isMemberCreditApplied}
        className={className}
      >
        <FormattedMessage
          id="site_account_rewards.nmp_reward_promo_conflict_text"
          defaultMessage="You can either use our current promotional offer to
            your order, or apply you available Credits(s).
            To switch between promo discount and credits(s) - use
            the toggle above."
        />
      </Container>
    );
  }
}

export default toastWrapper(PromoConflict);
